
import React, { Fragment, useState } from 'react';
import ButtonIcon from '@visa/vds/button-icon';
import ButtonText from '@visa/vds/button-text';
import Col from '@visa/vds/col';
import Grid from '@visa/vds/grid';
import Icon from '@visa/vds/icon';
import Row from '@visa/vds/row';
import Typography from '@visa/vds/typography';
import Radio from '@visa/vds/radio';
import RadioErrorMessage from '@visa/vds/radio-error-message';
import RadioGroup from '@visa/vds/radio-group';
import RadioGroupControl from '@visa/vds/radio-group-control';
import RadioGroupLegend from '@visa/vds/radio-group-legend';
import Checkbox from '@visa/vds/checkbox';
import CheckboxErrorMessage from '@visa/vds/checkbox-error-message';
import CheckboxList from '@visa/vds/checkbox-list';
import CheckboxListItem from '@visa/vds/checkbox-list-item';
import CheckboxSet from '@visa/vds/checkbox-set';
import CheckboxSetLegend from '@visa/vds/checkbox-set-legend';
import Divider from '@visa/vds/divider';
import DateSelector from '@visa/vds/date-selector';
import enUS from 'date-fns/locale/en-US';
import format from 'date-fns/format';
import VSTTSubscriptionComponent from './VSTT/VSTTSubscriptionComponent';
import { ProductSelectionConst } from './ProductSelectionLogic';
import '../../Style/Store.css';

const VSTTProductDetails = (props) => {


    return (
        <>
            <Divider type="section" />
            <VSTTSubscriptionComponent AUDIENCE_IDENTIFIER={ProductSelectionConst.ISSUE_TEST_MERCHANT} handleVSTTAudienceSelected={props.setIsVSTTMerchantSelected}
                selectedVSTTAudience={props.isVSTTMerchantSelected} selectedEnvironments={props.selectedVSTTProducts} setSelectedEnvironments={props.setSelectedVSTTProducts}
                subscriptionLabel={<b>VSTT Merchant</b>}
                AUDIENCE_PROD_ID={ProductSelectionConst.TEST_MERCHANT_PROD_PRODUCT} AUDIENCE_PREPROD_ID={ProductSelectionConst.TEST_MERCHANT_PRE_PROD_PRODUCT}
                AUDIENCE_SUSCRIPTION_MONTHLY={ProductSelectionConst.MONTHLY_MERCHANT} AUDIENCE_SUSCRIPTION_YEARLY={ProductSelectionConst.ANNUAL_MERCHANT}
                showVSTTProductEnvironmentErrorMessage={props.showVSTTProductEnvironmentErrorMessage}
                subscriptionCaption="Is an interactive, EMV 3DS-enabled simulated merchant eCommerce site which can send and receive authentication messages to/from the issuer’s ACS. VSTT Merchant is available 
                in Pre-Production and Production. Includes the use of Visa’s Directory Server."
                id="VSTTMerchant"
                
            />
            <VSTTSubscriptionComponent AUDIENCE_IDENTIFIER={ProductSelectionConst.ACQUIRER_TEST_ACS} handleVSTTAudienceSelected={props.setIsVSTTACSSelected}
                selectedVSTTAudience={props.isVSTTACSSelected} selectedEnvironments={props.selectedVSTTProducts} setSelectedEnvironments={props.setSelectedVSTTProducts}
                subscriptionLabel={<b>VSTT Access Control Server (ACS)</b>}
                AUDIENCE_PROD_ID={ProductSelectionConst.TEST_ACS_PROD_PRODUCT} AUDIENCE_PREPROD_ID={ProductSelectionConst.TEST_ACS_PRE_PROD_PRODUCT}
                AUDIENCE_SUSCRIPTION_MONTHLY={ProductSelectionConst.MONTHLY_ACS} AUDIENCE_SUSCRIPTION_YEARLY={ProductSelectionConst.ANNUAL_ACS}
                showVSTTProductAudienceErrorMessage={props.showVSTTProductAudienceErrorMessage}
                showVSTTProductEnvironmentErrorMessage={props.showVSTTProductEnvironmentErrorMessage}
                subscriptionCaption="Is an EMV 3DS-enabled ACS with test PANs customized for merchant/3DS Server EMV 3DS testing. 
                VSTT ACS is available in Pre-Production and Production. Includes the use of Visa’s Directory Server."
                id="VSTTACS"
            />
            <Divider type="section" />
        </>
    );
}

export default VSTTProductDetails